import { render, staticRenderFns } from "./TypeKanban.vue?vue&type=template&id=e518ac18&"
import script from "./TypeKanban.vue?vue&type=script&lang=js&"
export * from "./TypeKanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports